module.exports = __webpack_public_path__ + "0f499ecbe99e89ff75ee06b400f376c7.svg";